/*eslint eqeqeq: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import { ApiKeyFetch } from "api/fetchers/apiKey";
import imgBreadcrumb from "assets/img/mex/travelBta/imgBreadcrum.png";
import BreadCurmb from "components/BreadCrumbMex/BreadCrumb";
import BreadCurmbPasos from "components/BreadCrumbMex/BreadCrumbTipo2";
import Page from "components/Page";
import ModalOcupaciones from "components/TravelMex/ModalOcupaciones";
import NewPlanesTBTA from "components/TravelMex/NewPlanesTBTA";
import {
  ambienteAplicacion
} from "constants/urls";
import { URLS_PHP_7 } from "constants/urls_v2";
import { useNavbarContext } from "contexts/NavbarContext";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { setBanderaPrimerPago } from "redux/actions/cotizacion.actions";
import { setTarifacion } from "redux/actionsMex/aCarrito";
import { FetchCatalogoBtaEmpresas } from "redux/actionsMex/aCatalogos";
import { PASOS_BREADCRUMBS } from "utils/constants";
import PRODUCTOS from "utils/constants/PRODUCTOS";
import Loading from "wrappers/Loading";

const pasos = [
  {
    title: "1. Datos personales",
    active: true,
  },
  {
    title: "2. Elige el plan",
    active: true,
  },
  {
    title: "3. Opción de pago",
  },
  {
    title: "4. Confirma tu compra",
  },
];

const API = ApiKeyFetch.instance();

const NewTravelEmpresas = ({ qParams, addWarningToast, history }) => {
  useNavbarContext(PRODUCTOS.TRAVELBTA);

  const { id } = qParams;
  const idCotizacion = useSelector((state) => state.CarritoMex.setIdCotizacionActual.id);

  const [loading, setLoading] = useState(false);
  const [loadingText] = useState("Cargando...");

  const dispatch = useDispatch();

  const methods = useForm({ mode: "onChange" });

  const [planes, setPlanes] = useState([]);

  const [minimoDias, setMinimoDias] = useState(1);
  const [maximoDias, setMaximoDias] = useState(200);

  const [ocupaciones, setOcupaciones] = useState([]);

  const UsuarioDatos = useSelector((state) => state.datosUsuarios.dataUsuario);

  const [breadCrumbPasos, setBreadCrumbPasos] = useState(
    PASOS_BREADCRUMBS.TRAVELBTA.breadCrumbPasos[2]
  );

  const tarifar = async (id) => {
    const Data = {
      ambiente: ambienteAplicacion,
      cotCodigo: id,
      idPlazo: "1",
      formaPago: "contado",
      labelPlazo: "CONTADO",
    };

    return await API.post(URLS_PHP_7.cotizacion.tarifacionCotizacion, Data);
  };

  const init = useCallback(async () => {
    console.log("CATALOGO: ");
    const Data = {
      datosCotizador: {
        prodCodigo: PRODUCTOS.TRAVELBTA,
      },
    };

    if (UsuarioDatos && UsuarioDatos.userIsLoggedIn === true) {
      Data.usuCotiza = { usuCodigo: UsuarioDatos.cliCodigoCore };
    }

    if (UsuarioDatos.cliCodigoCore) {
      Data.datosCotizador.usuCotiza = {
        usuCodigo: UsuarioDatos.cliCodigoCore,
      };
    }

    const res = await API.post(URLS_PHP_7.cotizacion.catalogosCotizador, Data);

    if (res.transaccion && res.catalogo) {
      const { diasValorMinimo, diasValorMaximo } = res?.catalogo?.diasNumero;

      setBreadCrumbPasos({
        ...breadCrumbPasos,
        subtitle: `Puedes comprar desde ${diasValorMinimo} días mínimo, elegir 1 o más opciones y hasta un máximo de ${Number(
          diasValorMaximo
        ).toLocaleString()} días. ¡Buen viaje!`,
        // subtitleStyles: { maxWidth: '830px' },
        subtitleClassnames: "breadcrumb__paso__2__tbta",
      });
      const { catalogo } = res;
      dispatch(FetchCatalogoBtaEmpresas(catalogo));
      setMinimoDias(catalogo.diasNumero.diasValorMinimo);
      setMaximoDias(catalogo.diasNumero.diasValorMaximo);
      setOcupaciones(catalogo?.ocupacionesExclusion);
      //RECUPERA LA COTIZACION
      if (id) {
        const resTarifar = await tarifar(id);
        console.log(resTarifar);
        const misPlanesArray = resTarifar.datosTarifacion.planes;

        //SE CLONA EL ARRAY
        setPlanes(mappPlanesSeleccionados(misPlanesArray, misPlanesArray));
        setFormFromPlanes(misPlanesArray);
      } else {
        const newPlanes = processPlanes(catalogo.planes);
        setPlanes(mappPlanesSeleccionados(newPlanes, []));
      }

      console.log("RES: ", res);
    } else {
      addWarningToast("Algo ha salido mal intenta nuevamente");
    }
    setLoading(false);
  }, []);

  const setFormFromPlanes = (planes) => {
    const misPlanesObj = Object.fromEntries(
      planes.map((e) => [e.planCodigo, e.diasNumero])
    );

    methods.reset(misPlanesObj);
  };

  const processPlanes = (planes) => {
    return planes.map((e) => {
      let bandSeleccion = false;

      if (e.bandSeleccion) {
        bandSeleccion = true;
      }
      if (e.diasNumero === 0) {
        e.diasNumero = "";
      }

      return { ...e, bandSeleccion };
    });
  };

  useEffect(() => {
    setLoading(true);
    init();
  }, [init]);

  const setValueInPlanes = (plan, value, selected) => {
    const index = planes.findIndex((e) => e.planCodigo === plan.planCodigo);
    const planFind = planes[index];
    planFind.diasNumero = Number(value);
    planFind.bandSeleccion = selected;
    planes[index] = planFind;
    setPlanes(planes);

    //const activarRecalcular = planes.filter((e) => e.bandSeleccion).length > 0;
  };

  const validarDias = () => {
    try {
      /*
      const diasTotales = planes
        .map((e) => Number(e.diasNumero))
        .reduce((acum, dias) => acum + dias);
      */
      const planesBlancos = planes.filter(
        (e) => e.diasNumero === "" || e.diasNumero === 0
      );

      if (planesBlancos.length === planes.length) {
        addWarningToast("Seleccione mínimo un plan para continuar");
        return false;
      }

      const planesInvalidos = planes
        .filter((e) => e.diasNumero !== "" && e.diasNumero != 0)
        .filter((e) => e.diasNumero > maximoDias || e.diasNumero < minimoDias);

      if (planesInvalidos.length > 0) {
        addWarningToast(
          `El mínimo de dias es de ${minimoDias} y el máximo de dias es de ${maximoDias}`
        );
        return false;
      }

      return true;
      /*
      if (diasTotales === 0) {
        addWarningToast('Debe seleccionar un plan para poder continuar');
        return false;
      }
      console.log('DIAS TOTALES: ', diasTotales);
      if (diasTotales >= minimoDias && diasTotales <= maximoDias) {
        return true;
      } else {
        addWarningToast(
          `El mínimo de dias es de ${minimoDias} y el máximo de dias es de ${maximoDias}`,
        );
        return false;
      }
      */
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  const onClickCalcular = async () => {
    const isValid = validarDias();
    if (isValid) {
      setLoading(true);

      const Data = {
        ambiente: ambienteAplicacion,
        prodCodigo: PRODUCTOS.TRAVELBTA,
        pasoCodigo: "planes",
        tarifacionPantallaDos: false,
        idCotizacion,
        usuCotiza: UsuarioDatos.cliCodigoCore || "",
        items: {
          cotCodigo: idCotizacion,
          planes,
        },
      };
      console.log("DATA: ", JSON.stringify(Data));
      if (UsuarioDatos && UsuarioDatos.userIsLoggedIn) {
        Data.items.usuCotiza = { usuCodigo: UsuarioDatos.cliCodigoCore };
      }

      const res = await API.post(URLS_PHP_7.cotizacion.guardarPlanes, Data);

      if (res?.transaccion === true && res?.data) {
        console.log("RES: ", res);
        const misPlanes = processPlanes(res?.data.datosTarifacion.planes);

        const newPlanes = mappPlanesSeleccionados(planes, misPlanes);

        setPlanes(newPlanes);

        setFormFromPlanes(newPlanes);

        dispatch(setTarifacion(res?.data?.datosTarifacion));
        history.replace({
          pathname: "/travel-empresas-planes",
          search: `?id=${idCotizacion}`,
        });
      } else {
        return addWarningToast(
          "Ha ocurrido un problema al guardar la información de la tarifación"
        );
      }

      setLoading(false);
    }
  };

  const onClickContinuar = async () => {
    const isValid = validarDias();

    if (isValid) {
      const calculados = planes.some((item) => item.total);
      if (!calculados) {
        return addWarningToast(
          "Debe realizar el cálculo de algún plan para poder continuar"
        );
      }
      history.push({
        pathname: "/travel-empresas-resumen",
        search: `?id=${id}`,
      });
    }
  };

  const mappPlanesSeleccionados = (planes, misPlanes) => {
    console.log("MIS PLANES: ", misPlanes);
    return planes.map((plan) => {
      plan.total = 0;

      const planSeleccionado = misPlanes
        .map((planSeleccionado) => ({
          ...planSeleccionado,
          valorTotal: planSeleccionado?.valorTotal?.find?.((e) => e.banderaMoneda),
        }))
        .find(
          (planSeleccionado) =>
            planSeleccionado.planNombre === plan.planNombre && planSeleccionado.valorTotal
        );

      if (planSeleccionado?.valorTotal) {
        plan.total = planSeleccionado?.valorTotal?.primaNeta;
      }

      return plan;
    });
  };

  return (
    <Loading loading={loading} message={loadingText}>
      <FormProvider {...methods}>
        <main className='cr-content'>
          <Page>
            <BreadCurmb {...PASOS_BREADCRUMBS.TRAVELBTA.breadCrumb} />

            <BreadCurmbPasos {...breadCrumbPasos} pasos={pasos} img={imgBreadcrumb} />
            <NewPlanesTBTA
              planes={planes}
              setValueInPlanes={setValueInPlanes}
              minimoDias={minimoDias}
              maximoDias={maximoDias}
              onClickCalcular={onClickCalcular}
            />
            <ModalOcupaciones ocupaciones={ocupaciones} />
          </Page>
          <div className='row justify-content-center my-5'>
            <div className='col-8 col-md-6 col-xl-2'>
              <button className='btn btn-siguiente-api' onClick={onClickContinuar}>
                Continuar
              </button>
            </div>
          </div>
        </main>
      </FormProvider>
    </Loading>
  );
};

export default NewTravelEmpresas;
